module.exports = __webpack_public_path__ + "img/Vector31.1252cd6e.svg";